import {
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useTranslation } from "react-i18next";

const SEARCH_PLACEHOLDERS = {
  ar: "بحث في Mapapet",
  de: "Mapapet durchsuchen",
  en: "Search Mapapet",
  es: "Buscar en Mapapet",
  fr: "Rechercher sur Mapapet",
  hi: "Mapapet में खोजें",
  id: "Cari di Mapapet",
  it: "Cerca su Mapapet",
  ja: "Mapapetを検索",
  ko: "Mapapet 검색",
  pl: "Szukaj w Mapapet",
  pt: "Pesquisar no Mapapet",
  ru: "Поиск по Mapapet",
  tr: "Mapapet'te ara",
  uk: "Пошук у Mapapet",
  zh: "搜索 Mapapet",
};

const getShortLanguage = (language = "en") => {
  const short = String(language)
    .toLowerCase()
    .split("-")[0];

  return short === "ua" ? "uk" : short;
};

const readQueryFromLocation = (search = "") => {
  const params = new URLSearchParams(search);
  return String(params.get("q") || "").trim();
};

const DeferredGoogleSearch = ({
  className = "",
}) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [query, setQuery] = useState(() =>
    location.pathname === "/search"
      ? readQueryFromLocation(location.search)
      : ""
  );

  const language = getShortLanguage(
    i18n.resolvedLanguage || i18n.language
  );

  const placeholder = useMemo(
    () =>
      SEARCH_PLACEHOLDERS[language] ||
      SEARCH_PLACEHOLDERS.en,
    [language]
  );

  useEffect(() => {
    if (location.pathname !== "/search") {
      return;
    }

    setQuery(
      readQueryFromLocation(location.search)
    );
  }, [
    location.pathname,
    location.search,
  ]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const normalizedQuery = query.trim();
    if (!normalizedQuery) return;

    const nextSearch =
      `?q=${encodeURIComponent(normalizedQuery)}`;

    if (
      location.pathname === "/search" &&
      location.search === nextSearch
    ) {
      return;
    }

    navigate({
      pathname: "/search",
      search: nextSearch,
    });
  };

  const wrapperClassName = [
    "header-deferred-search",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <form
      className={`${wrapperClassName} header-deferred-search__form`}
      role="search"
      onSubmit={handleSubmit}
    >
      <input
        type="search"
        className="header-deferred-search__input"
        value={query}
        onChange={(event) =>
          setQuery(event.target.value)
        }
        placeholder={placeholder}
        aria-label={placeholder}
        autoComplete="off"
        enterKeyHint="search"
      />

      <button
        type="submit"
        className="header-deferred-search__button"
        aria-label={placeholder}
      >
        <span aria-hidden="true">⌕</span>
      </button>
    </form>
  );
};

export default DeferredGoogleSearch;
